<script setup lang="ts">
import type { FormControl } from "@/utils/forms";
import { CheckBoxComponent as EjsCheckbox } from "@syncfusion/ej2-vue-buttons";

withDefaults(defineProps<{
    control: FormControl<boolean>;
    label?: string;
}>(), {
});

</script>

<template>
    <div>

        <ejs-checkbox v-model="control.value" :label='label'></ejs-checkbox>

    </div>
</template>
